import { render, staticRenderFns } from "./DashboardTopTable.vue?vue&type=template&id=460aa216&"
import script from "./DashboardTopTable.vue?vue&type=script&lang=js&"
export * from "./DashboardTopTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports